module.exports = __webpack_public_path__ + "img/pantalla2-7.5641355b.png";